import styled from "styled-components";
import Colors from "../../themes/Colors";

const CartInitialBudgetStyleHolder = styled.div`
  .cartBudget {
    position: static;
    z-index: 996;
    height: auto;
    background-color: ${Colors.primary};
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
    padding: 8px 10px 10px;
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    color: ${Colors.onPrimary};
    margin: 0;
    min-width: 0;
  }
  .text-title {
    font-size: 20px;
  }
  span {
    font-size: 16px;
    color: inherit;
  }

  h3 {
    color: inherit;
    font-size: 24px;
    font-weight: 500;
    text-transform: capitalize;
    margin: 0;
  }

  svg {
    font-size: 20px;
  }
  .titleInfo {
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    color: ${Colors.onPrimarySoft};
    margin-left: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .infoDate {
    margin-top: 5px;
    margin-bottom: 1px;
    font-size: 12px;
    font-weight: 600;
    line-height: 22px;
    text-align: right;
    color: ${Colors.onPrimarySoft};
    margin-right: 10px;
  }
  .ant-row-flex {
    align-items: baseline;
    flex-wrap: nowrap;
    gap: 8px;
  }
  .content-info {
    padding: 2px;
    border-radius: 4px;
    background-color: ${Colors.snow};
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    color: ${Colors.primaryAccent};
    margin-right: 0;
    overflow-wrap: anywhere;
    span {
      font-size: 13px;
    }
  }
  .groupFilterButton {
    background-color: transparent;
    color: ${Colors.white};
    border-radius: 4px;
    padding: 4px 10px;
    height: 32px;
    border: 1px solid ${Colors.white};
    .balanceButtonText {
      font-size: 12px;
    }
  }
}`;

export default CartInitialBudgetStyleHolder;